import React from 'react';
import { getPortalFromHostname, PORTAL_SURFACES } from '../../utils/hostnamePortal';
import Signup from './Signup';
import FundGeniusSignup from './FundGeniusSignup';

const AuthSignupRoute = () => {
  const portal = getPortalFromHostname();
  if (
    portal === PORTAL_SURFACES.FUNDGENIUS_APP
    || portal === PORTAL_SURFACES.FUNDGENIUS_MARKETING
  ) {
    return <FundGeniusSignup />;
  }
  return <Signup />;
};

export default AuthSignupRoute;
